import {
	checkMark,
	crossmark,
	ellipse,
	line,
	pentagon,
	rect,
	rightArrow,
	roundRect,
	star5,
	triangle,
	wedgeRectCallout,
} from "./index";

/**
 * Preset geometry collection object.
 * Key in object is preset geometry name and value against key is actual preset
 * geometry
 */
export const presetGeometries: any = {
	rect, ellipse, triangle, pentagon,
	star5, rightArrow, roundRect, wedgeRectCallout, line, crossmark, checkMark,
};
